import type { SupportLocale } from "@/locales/fr/support";

import { ESupportType } from "@/types/backoffice/dto/reference/support-type-dto.ts";

const supportLocale: SupportLocale = {
  support: {
    title: "Support",
    supportRequest: "Support request",
    supportType: "Support type",
    subscriberNeed: {
      label: "Subscriber need",
    },
    success: "Support request sent successfully",
    error: "An error occurred while sending the support request",
    sendSupportRequest: "Send support request",
    type: {
      [ESupportType.TECHNICAL_ASSISTANCE_NOT_URGENT]: "Technical Assistance - not urgent",
      [ESupportType.TECHNICAL_ASSISTANCE_URGENT]: "Technical Assistance - urgent",
      [ESupportType.CLAIM]: "Claim",
      [ESupportType.PLANIF_NOT_URGENT]: "Planif - not urgent",
      [ESupportType.PLANIF_URGENT]: "Planif - urgent",
      [ESupportType.IV_TECH_NOT_URGENT]: "IV Tech - not urgent",
      [ESupportType.IV_TECH_URGENT]: "IV Tech - urgent",
      [ESupportType.AIRRIA_NOT_URGENT]: "Airria - not urgent",
      [ESupportType.AIRRIA_URGENT]: "Airria - urgent",
      [ESupportType.CIRCET_NOT_URGENT]: "Circet - not urgent",
      [ESupportType.CIRCET_URGENT]: "Circet - urgent",
      [ESupportType.S30_NOT_URGENT]: "S30 - not urgent",
      [ESupportType.S30_URGENT]: "S30 - urgent",
      [ESupportType.BUGBUSTERS_NOT_URGENT]: "Bugbusters - not urgent",
      [ESupportType.BUGBUSTERS_URGENT]: "Bugbusters - urgent",
      [ESupportType.PAC]: "Heat Pump (PAC)",
      [ESupportType.PSB]: "Saint Bernard Program (PSB)",
      [ESupportType.CLIMATISATION]: "Air conditioning",
      [ESupportType.TERTIAIRE]: "Tertiary",
    },
  },
};

export default supportLocale;
